export default __webpack_public_path__ + "static/media/az-logo.103e9f0d.png";